import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { Container, Typography, Grid, Box,  } from '@mui/material';

function PIB() {
  return (
    <div style={{ backgroundColor: '#e3f2fd', paddingBottom: '40px' }}>
      <NavigationBar />
       <Typography variant="h5" fontWeight="bold" gutterBottom>
                 <br />  
            </Typography>
      <Container maxWidth="lg" sx={{ paddingTop: 5, paddingBottom: 5 }}>
       
        <Box sx={{ backgroundColor: '#ffffff', padding: 3, borderRadius: 2, boxShadow: 1 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={5}>
              <Typography variant="h6" align="left" gutterBottom sx={{ color: '#388E3C' }}>
                Produit Intérieur Brut (PIB)
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>PIB aux prix courants (2019):</strong> 6,217.0 milliards de BIF
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Taux de croissance du PIB réel (2019):</strong> 4.5%
              </Typography>
            </Grid>
            {/*
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" align="left" gutterBottom sx={{ color: '#388E3C' }}>
                Productions et Exportations
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Principales productions vivrières:</strong> Maïs, Haricots, Bananes et Patates douces.
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Principales exportations:</strong> Café et Thé.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography variant="h6" align="left" gutterBottom sx={{ color: '#388E3C' }}>
                Finances Publiques
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Recettes totales (hors dons, T3 2024):</strong> 498.7 milliards de BIF
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Dons en capitalS (T2 2022):</strong> 61.6 milliards de BIF
              </Typography>
            </Grid>
            */}
          </Grid>
        </Box>
      </Container>
      <Footer />
    </div>
  );
}

export default PIB;